function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* @indexer:no-export */
import React, { useEffect } from 'react';
import styles from './AccordionButton.module.scss';
import { formatI18n } from '../../I18n/I18n/I18n';
import ChevronCaret from '../../Icons/ChevronCaret/ChevronCaret';
import cs from 'classnames';
import { useAccordionContext } from '../Accordion/Accordion';
import { injectIntl } from 'react-intl';
// default button
export function AccordionButtonInner(_ref) {
  var buttonProps = _ref.buttonProps,
    checked = _ref.checked,
    label = _ref.label;
  return /*#__PURE__*/React.createElement("button", buttonProps, /*#__PURE__*/React.createElement("span", {
    className: styles.caret,
    "aria-hidden": true
  }, /*#__PURE__*/React.createElement(ChevronCaret, {
    direction: checked ? 'down' : 'right',
    width: 13,
    height: 13,
    style: {
      width: 'auto'
    }
  })), label);
}
function AccordionButton(_ref2) {
  var _ref2$defaultOpen = _ref2.defaultOpen,
    defaultOpen = _ref2$defaultOpen === void 0 ? false : _ref2$defaultOpen,
    id = _ref2.id,
    _ref2$title = _ref2.title,
    title = _ref2$title === void 0 ? '' : _ref2$title,
    checked = _ref2.checked,
    children = _ref2.children,
    intl = _ref2.intl;
  var _useAccordionContext = useAccordionContext('AccordionButton'),
    namespace = _useAccordionContext.namespace,
    dispatch = _useAccordionContext.dispatch,
    type = _useAccordionContext.type; // ugly, but needed to not have this twice down below...
  // using dispatch directly instead of handleChange also allows this to only
  // run on initial render because of stable identity
  // see: https://reactjs.org/docs/hooks-reference.html#usereducer
  var handleClick = function handleClick() {
    dispatch({
      type: checked ? "off:".concat(type) : "on:".concat(type),
      payload: id
    });
  };
  useEffect(function () {
    dispatch({
      type: defaultOpen ? "on:".concat(type) : "off:".concat(type),
      payload: id
    });
  }, [id, defaultOpen, dispatch, type]);
  return (
    /*#__PURE__*/
    // use a Fragment because `ReactNode` could be an Array of children which
    // you can't have on its own
    // see: https://github.com/DefinitelyTyped/DefinitelyTyped/issues/18051
    React.createElement(React.Fragment, null, children({
      buttonProps: {
        id: id,
        type: 'button',
        className: cs(styles.button, 'auto-accordion-label', _defineProperty({}, "auto-accordion-label--".concat(namespace), namespace)),
        'aria-expanded': checked,
        onClick: handleClick
      },
      checked: checked,
      label: formatI18n(intl, title)
    }))
  );
}
export default injectIntl(AccordionButton);